import { type AscProject } from '@neo.tax/asc/hooks';

import { PredictedCapitalizationStatusBadge } from '../predicted-capitalization-status';
import { StyledTooltip } from './asc-projects-layout.styled';

export type AscProjectCapitalizedAIGuidanceCellProps = {
  ascProject: AscProject;
};

export const AscProjectCapitalizedAIGuidanceCell = ({
  ascProject,
}: AscProjectCapitalizedAIGuidanceCellProps): React.ReactElement => (
  <StyledTooltip
    text={ascProject.predictedCapitalizationStatusReason}
    options={{
      placement: 'bottom',
      showArrow: true,
    }}
  >
    <PredictedCapitalizationStatusBadge status={ascProject.predictedCapitalizationStatus} />
  </StyledTooltip>
);
